import { render, staticRenderFns } from "./dueTo.vue?vue&type=template&id=95cdab36&scoped=true&"
import script from "./dueTo.vue?vue&type=script&lang=js&"
export * from "./dueTo.vue?vue&type=script&lang=js&"
import style0 from "./dueTo.vue?vue&type=style&index=0&id=95cdab36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cdab36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\scpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95cdab36')) {
      api.createRecord('95cdab36', component.options)
    } else {
      api.reload('95cdab36', component.options)
    }
    module.hot.accept("./dueTo.vue?vue&type=template&id=95cdab36&scoped=true&", function () {
      api.rerender('95cdab36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dueTo.vue"
export default component.exports